// extracted by mini-css-extract-plugin
export default {"action":"search_filters_bar_action-module__action--BvLeb"};